module.exports = __webpack_public_path__ + "static/media/curology-bottles-on-pink-background.4b791301.jpg";